export enum NudgeReferenceType {
    Patient = 0, 
    PatientDocument = 1,
    PatientClinicDocument = 2,
    Service = 3, 
    Product = 4,
    ClinicSupply = 5,
    PatientForm = 6,
}
